const types = {
  GET_DATA_VALIDATION: 'GET_DATA_VALIDATION',
  GENERATE_DATA_VALIDATION: 'GENERATE_DATA_VALIDATION',
  RESET_STORE: 'RESET_STORE',
};

export default types;
